import {useQuery} from 'react-query';
import {getAutocomplete} from '../global/helpers';
import {AutocompleteKey} from "../constants/Keys";

export const useAutoComplete = () => {
    return useQuery(AutocompleteKey, () => getAutocomplete().then((resp) => resp.data));
};
